import * as api from '../../../api/dashboard/dashboardApi';
import * as types from '../../types/dashboard/dashboardTypes';

// Get all dashboard data
export const getDashboardData = (params = {}) => async (dispatch) => {
  console.log('Redux: Dispatching GET_DASHBOARD_DATA_REQUEST with params:', params);
  dispatch({ type: types.GET_DASHBOARD_DATA_REQUEST });
  try {
    const [recentIssues, recentReturns, pendingData, productionData, batchSummary, pendingSummary] = await Promise.all([
      api.getRecentStockIssues(params),
      api.getRecentStockReturns(params),
      api.getDepartmentWisePendingData(params),
      api.getDepartmentWiseProductionData(params),
      api.getBatchSummary(params),
      api.getPendingSummary(params)
    ]);
    const data = {
      recentIssues,
      recentReturns,
      departmentWisePending: pendingData,
      departmentWiseProduction: productionData,
      batchSummary,
      pendingSummary
    };
    console.log('Redux: Dispatching GET_DASHBOARD_DATA_SUCCESS with data:', data);
    dispatch({ type: types.GET_DASHBOARD_DATA_SUCCESS, payload: data });
  } catch (error) {
    console.error('Redux: Dispatching GET_DASHBOARD_DATA_FAILURE with error:', error);
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch dashboard data';
    dispatch({ type: types.GET_DASHBOARD_DATA_FAILURE, payload: errorMessage });
  }
};

// Get recent stock issues
export const getRecentStockIssues = (params = {}) => async (dispatch) => {
  console.log('Redux: Dispatching GET_RECENT_STOCK_ISSUES_REQUEST with params:', params);
  dispatch({ type: types.GET_RECENT_STOCK_ISSUES_REQUEST });
  try {
    const data = await api.getRecentStockIssues(params);
    console.log('Redux: Dispatching GET_RECENT_STOCK_ISSUES_SUCCESS with data:', data);
    dispatch({ type: types.GET_RECENT_STOCK_ISSUES_SUCCESS, payload: data });
  } catch (error) {
    console.error('Redux: Dispatching GET_RECENT_STOCK_ISSUES_FAILURE with error:', error);
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch recent stock issues';
    dispatch({ type: types.GET_RECENT_STOCK_ISSUES_FAILURE, payload: errorMessage });
  }
};

// Get recent stock returns
export const getRecentStockReturns = (params = {}) => async (dispatch) => {
  console.log('Redux: Dispatching GET_RECENT_STOCK_RETURNS_REQUEST with params:', params);
  dispatch({ type: types.GET_RECENT_STOCK_RETURNS_REQUEST });
  try {
    const data = await api.getRecentStockReturns(params);
    console.log('Redux: Dispatching GET_RECENT_STOCK_RETURNS_SUCCESS with data:', data);
    dispatch({ type: types.GET_RECENT_STOCK_RETURNS_SUCCESS, payload: data });
  } catch (error) {
    console.error('Redux: Dispatching GET_RECENT_STOCK_RETURNS_FAILURE with error:', error);
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch recent stock returns';
    dispatch({ type: types.GET_RECENT_STOCK_RETURNS_FAILURE, payload: errorMessage });
  }
};

// Get department-wise pending data
export const getDepartmentWisePendingData = (params = {}) => async (dispatch) => {
  console.log('Redux: Dispatching GET_DEPARTMENT_WISE_PENDING_REQUEST with params:', params);
  dispatch({ type: types.GET_DEPARTMENT_WISE_PENDING_REQUEST });
  try {
    const data = await api.getDepartmentWisePendingData(params);
    console.log('Redux: Dispatching GET_DEPARTMENT_WISE_PENDING_SUCCESS with data:', data);
    dispatch({ type: types.GET_DEPARTMENT_WISE_PENDING_SUCCESS, payload: data });
  } catch (error) {
    console.error('Redux: Dispatching GET_DEPARTMENT_WISE_PENDING_FAILURE with error:', error);
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch department-wise pending data';
    dispatch({ type: types.GET_DEPARTMENT_WISE_PENDING_FAILURE, payload: errorMessage });
  }
};

// Get department-wise production data
export const getDepartmentWiseProductionData = (params = {}) => async (dispatch) => {
  console.log('Redux: Dispatching GET_DEPARTMENT_WISE_PRODUCTION_REQUEST with params:', params);
  dispatch({ type: types.GET_DEPARTMENT_WISE_PRODUCTION_REQUEST });
  try {
    const data = await api.getDepartmentWiseProductionData(params);
    console.log('Redux: Dispatching GET_DEPARTMENT_WISE_PRODUCTION_SUCCESS with data:', data);
    dispatch({ type: types.GET_DEPARTMENT_WISE_PRODUCTION_SUCCESS, payload: data });
  } catch (error) {
    console.error('Redux: Dispatching GET_DEPARTMENT_WISE_PRODUCTION_FAILURE with error:', error);
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch department-wise production data';
    dispatch({ type: types.GET_DEPARTMENT_WISE_PRODUCTION_FAILURE, payload: errorMessage });
  }
};

// Set dashboard filters
export const setDashboardFilters = (filters) => (dispatch) => {
  console.log('Redux: Dispatching SET_DASHBOARD_FILTERS with filters:', filters);
  dispatch({ type: types.SET_DASHBOARD_FILTERS, payload: filters });
};

// Reset dashboard filters
export const resetDashboardFilters = () => (dispatch) => {
  console.log('Redux: Dispatching RESET_DASHBOARD_FILTERS');
  dispatch({ type: types.RESET_DASHBOARD_FILTERS });
};

export const getBatchSummary = (params = {}) => async (dispatch) => {
  dispatch({ type: types.GET_BATCH_SUMMARY_REQUEST });
  try {
    const data = await api.getBatchSummary(params);
    dispatch({ type: types.GET_BATCH_SUMMARY_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch batch summary';
    dispatch({ type: types.GET_BATCH_SUMMARY_FAILURE, payload: errorMessage });
  }
};

export const getPendingSummary = (params = {}) => async (dispatch) => {
  dispatch({ type: types.GET_PENDING_SUMMARY_REQUEST });
  try {
    const data = await api.getPendingSummary(params);
    dispatch({ type: types.GET_PENDING_SUMMARY_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch pending summary';
    dispatch({ type: types.GET_PENDING_SUMMARY_FAILURE, payload: errorMessage });
  }
}; 